import styled from 'styled-components'
import { colors, derivedColors } from '../../const'
import { Link as ReactRouterLink } from 'react-router-dom'

export const PrincipalContainer = styled.div`
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:space-between;
  background-color: ${colors.pageBackground};
`

export const OutterContainer = styled.div`
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 93vh;
  width: 100%;
`

export const InnerContainer = styled.div`
  align-items: center;
  justify-content: center;
  background: ${colors.surface};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  height: auto;
  width: 100%;
  max-width: 480px;
  padding: 40px;
  margin-top: 20px;
  transition: 0.2s;

  @media screen and (max-width: 1550px) {
    margin-top: 2%;
  }
`

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0;
  position: static;

  &::after {
    display: none;
  }
`

export const Logo = styled.img`
  margin: 0 auto;
  width: 200px;
`

export const Title = styled.h2`
  color: ${colors.textSecondary};

  letter-spacing: 0em;
  margin: 0 0 24px;
`

export const FormWrapper = styled.form`
  width: 100%;
  padding: 0;
`

export const InputAndLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px 0;
  width: 100%;
`

export const InputWrapper = styled.div`
  align-items: center;
  background: ${colors.surface};
  border: 1px solid ${colors.borderSubtle};
  border-radius: 6px;
  display: flex;
  position: relative;

  &:focus-within {
    outline: none;
    outline: 2px solid ${colors.primary};
    box-shadow: 0 0 0 2px ${derivedColors.primaryFocusShadow};
    outline-offset: 2px;
  }
`

export const Label = styled.label`
  color: ${colors.textSecondary};
  font-family: 'Inter';
  font-size: 0.875rem;
  font-weight: 600;
  margin: 0 0 8px;
`

export const Input = styled.input`
  border: none;
  flex-grow: 1;
  padding: 12px 12px;
  width: calc(100% - 48px);
  background-color: transparent;

  &:focus {
    outline: none;
  }
`

export const LockIcon = styled.img`
  height: 16px;
  padding-left: 12px;
  width: auto;
  margin-right: 8px;
`

export const EyeIconWrapper = styled.div`
  align-items: center;
  background: transparent;
  border-radius: 0;
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 48px;
  position: absolute;
  right: 0;
`

export const EyeIcon = styled.img`
`

export const ForgotPassword = styled.button`
  color: ${colors.primary};
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  display: block;

  &:hover {
    text-decoration: underline;
  }
`

export const Button = styled.button`
  background-color: ${colors.primary};
  border: none;
  border-radius: 6px;
  color: ${colors.surface};
  cursor: pointer;
  display: block;
  width: 100%;
  padding: 12px 0;
  font-size: 1rem;
  font-weight: 500;
  margin: 24px auto 0;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${colors.primaryHover};
  }
`

export const Link = styled(ReactRouterLink)`
  margin: 0 auto;
`

export const ErrorMessage = styled.p`
  color: ${colors.error};
  font-family: 'Inter';
  font-size: 0.875rem;
  font-weight: 500;
  margin: 0 0 16px;
  text-align: left;
  width: 100%;
  line-height: 1.5;
  word-break: break-word;
  min-height: 1.25rem;
`

export const SupportLink = styled.a`
  color: ${colors.error};
  font-family: 'Inter';
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: underline;

  &:hover {
    opacity: 0.8;
  }
`
